<template>
  <v-container fluid fill-height>
    <v-layout flex align-center justify-center>
          <PotentialMeme @cast-vote="onCastVote($event)" :meme-data="currentPotentialMeme" v-if="hasMemesToVote"></PotentialMeme>
          <div v-else class="text-md-h3">Nothing To Vote On</div>
    </v-layout>
    <v-fade-transition>
      <v-overlay :value="isLoading" >
        <v-progress-circular indeterminate size="64"></v-progress-circular>
      </v-overlay>
    </v-fade-transition>
    <over18-diag></over18-diag>
  </v-container>


</template>

<script>
import {RepositoryFactory} from "@/services/api/RepositoryFactory";
import PotentialMeme from "@/components/meme-voting/PotentialMeme";
import Over18Diag from "@/components/common/Over18Diag";


const MemeRepo = RepositoryFactory.get('meme')
export default {
  name: "MemeVoting",
  components: {Over18Diag, PotentialMeme},
  data: () => ({
    potentialMemes: [],
    currentPotentialMeme: null,
    isLoading: true
  }),
  methods: {
    loadPotentialMemes() {
      this.isLoading = true;
      MemeRepo.getAllPotentialTemplates({params: {token: this.$store.getters.token}})
          .then(res => {
            if (res.status === 'error') {
              this.$emit('on-alert', {color: 'error', message: res.data})
              return;
            }
            this.potentialMemes = res.data;
            this.currentPotentialMeme = this.potentialMemes.pop()
            this.isLoading = false;
          })
    },
    onCastVote(vote) {
      if (!this.currentPotentialMeme) {
        console.log('No selected meme')
        return;
      }
      console.log('Casing vote ' + vote)

      // eslint-disable-next-line no-unreachable
      MemeRepo.votePotentialTemplate(this.currentPotentialMeme.id, {params: {vote: vote, token: this.$store.getters.token}})
        .then(res => {
          if (res.status === 'error') {
            this.$emit('on-alert', {color: 'error', message: res.data})
            return;
          }
          this.currentPotentialMeme = this.potentialMemes.pop();
        })
    }
  },
  mounted() {
    this.loadPotentialMemes();
  },
  computed: {
    hasMemesToVote() {
      return this.potentialMemes.length > 0;
    }
  }
}
</script>

<style scoped>

</style>